import React from "react";
import styles from "./Footer.module.css";
import logo from "../../resources/img/logoc7.png";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerLeft}>
        <ul>
          <li>
            <a href="/NewHere">¿Nuevo aquí?</a>
          </li>
          <li>
            <a href="/predicas">Prédicas</a>
          </li>
          <li>
            <a href="/about">Sobre nosotros</a>
          </li>
          <li>
            <a href="/privacidad">Aviso de privacidad</a>
          </li>
        </ul>
      </div>

      <div className={styles.footerCenter}>
         <Link to="/">
            <img src={logo} alt="Logo"  className={styles.logo} />
          </Link>
      </div>

      <div className={styles.footerRight}>
        <div className={styles.socialIcons}>
          <ul>
            <li>
              <a
                href="https://www.facebook.com/ElColectivoSiete/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon className={styles.socialIcon}  sx={{":hover":{color:"#1877f2"}}} fontSize="large" />
              </a>
            </li>
            <li>
              <a
                href="https://wa.me/+522221517369?text=Hola%20quiero%20conocer%20mas%20sobre%20colectivo%20siete"
                target="_blank"
                rel="noopener noreferrer"
              >
                <WhatsAppIcon className={styles.socialIcon}  sx={{":hover":{color:"#25d366"}}} fontSize="large" />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/elcolectivosiete/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon className={styles.socialIcon}  sx={{":hover":{color:"#cc2366"}}} fontSize="large" />
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/@colectivosiete1924"
                target="_blank"
                rel="noopener noreferrer"
              >
                <YouTubeIcon className={styles.socialIcon} sx={{":hover":{color:"red"}}} fontSize="large" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
